export default "/7c6d6d00b301eb9f3c9f301f30c99cc6.jpg";